module.exports = __webpack_public_path__ + "img/3_x12.a536e5e2.png";